query GetAccountRoles(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  rolesForAccount(
    accountId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        name
        id
        notes
      }
    }
  }
}
